<template>
  <div class="switch">
    <div @click="toggle" class="switchContainer" :class="{'true':currValue,'false':!currValue}">
      <p class="true" v-if="currValue">{{text[0]}}</p>
      <p class="false" v-if="!currValue">{{text[1]}}</p>
      <div class="picker" :class="{'true':currValue,'false':!currValue}"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "switchComp",
    props: {
      value: {
        type: Boolean,
        default: true
      },
      text: {
        type: Array,
        default() {
          return ['周', '月']
        }
      }
    },
    data() {
      return {
        currValue: null,
      }
    },
    computed: {},
    methods: {
      toggle() {
        this.currValue = !this.currValue;
        this.$emit("toggle", {value: this.currValue})
      }
    },
    mounted() {
      this.currValue = this.value;
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .switch
    display inline-block
    margin-top 6px
    margin-right 12px
    float right

    .switchContainer
      display inline-block
      width 50px
      height 22px
      border-radius 11px
      background-color themeColor
      position relative
      font-size 0
      cursor pointer
      transition 300ms
      user-select none

      &.false
        background-color themeColor

      &:hover
        box-shadow 1px 1px 2px #cccccc

      & > p
        display inline-block
        color #ffffff
        font-size 12px
        line-height 22px
        margin-left 12px
        float left

        &.false
          float right
          margin-right 8px

      .picker
        width 16px
        height 16px
        border-radius 50%
        border 1px solid #ffffff
        background-color #ffffff
        position absolute
        right 3px
        top 0
        bottom 0
        margin auto
        transition 300ms

        &.false
          transform translateX(-28px)
</style>



// WEBPACK FOOTER //
// src/components/globalComp/switch.vue